export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
    cards: [
      {n:'1', name:'Warriors of the Force', artist:'Chris Trevas'},
      {n:'2', name:'Darth Vader and Princess Leia', artist:'Chris Trevas'},
      {n:'3', name:'Not Part of the Bargain', artist:'Chris Trevas'},
      {n:'4', name:'Beyond the Cave', artist:'Chris Trevas'},
      {n:'5', name:'Luke Wields the Lightsaber', artist:'Chris Trevas'},
      {n:'6', name:'In the Heat of Battle', artist:'Tommy Lee Edwards'},
      {n:'7', name:"Anakin Skywalker's Revenge", artist:'Tommy Lee Edwards'},
      {n:'8', name:'Becoming Darth Vader', artist:'Tommy Lee Edwards'},
      {n:'9', name:'Battle of Kamino', artist:'Saby Menyhei'},
      {n:'10', name:"Jabba's Bounty Hunter", artist:'Saby Menyhei'},
      {n:'11', name:'There Is No Escape', artist:'Saby Menyhei'},
      {n:'12', name:'Imperial Shock Troopers', artist:'Clark Mitchell'},
      {n:'13', name:'Obi-Wan Kenobi', artist:'Clark Mitchell'},
      {n:'14', name:'Anakin Skywalker', artist:'Clark Mitchell'},
      {n:'15', name:'Battle-Ready', artist:'Clark Mitchell'},
      {n:'16', name:'Adventures of BB-8', artist:'Archives'},
      {n:'17', name:'The Force Awakens', artist:'Archives'},
      {n:'18', name:'Friends Forever', artist:'Archives'},
      {n:'19', name:'The Tatooine Gangster', artist:'Archives'},
      {n:'20', name:'Max Rebo Band', artist:'Archives'},
      {n:'21', name:'Starfighter in Battle', artist:'Archives'},
      {n:'22', name:'Han Solo in Carbonite', artist:'Archives'},
      {n:'23', name:'Kylo Ren', artist:'Archives'},
      {n:'24', name:"Boba Fett's Jetpack", artist:'Archives'},
      {n:'25', name:'Sith Lords', artist:'Archives'},
      {n:'26', name:'Defender of the Empire', artist:'Archives'},
      {n:'27', name:'Setting Suns', artist:'Marko Manev'},
      {n:'28', name:'The Dark Lord', artist:'Marko Manev'},
      {n:'29', name:'New Beginning', artist:'Marko Manev'},
      {n:'30', name:'A Look to the Past', artist:'Marko Manev'},
      {n:'31', name:'Mourning for Padmé', artist:'Erik Maell'},
      {n:'32', name:"Boba Fett's Prize", artist:'Kyle Babbitt'},
      {n:'33', name:"The Way of Mand'alor", artist:'Brent Woodside'},
      {n:'34', name:'Red Five', artist:'Brent Woodside'},
      {n:'35', name:'Victory and Death', artist:'Brent Woodside'},
      {n:'36', name:'The Hunter', artist:'Brent Woodside'},
      {n:'37', name:'The Rebels and the Rancor', artist:'Dave Dorman'},
      {n:'38', name:'Biker Scout Down', artist:'Dave Dorman'},
      {n:'39', name:'Knights of the Republic Issue #4', artist:'Dave Dorman'},
      {n:'40', name:'The Crimson Crusader', artist:'Dave Dorman'},
      {n:'41', name:'Watto', artist:'Matt Busch'},
      {n:'42', name:'Where the Fun Begins', artist:'Joshua Williams'},
      {n:'43', name:'Braver Than Most', artist:'Joshua Williams'},
      {n:'44', name:'Cloud City Gambit', artist:'Lee Kohse'},
      {n:'45', name:'AT-AT Drivers', artist:'Lee Kohse'},
      {n:'46', name:'Dagobah', artist:'Daniel Danger'},
      {n:'47', name:'The Legacy', artist:'Cliff Cramp'},
      {n:'48', name:'Communion in the Force', artist:'Dianne Vaznelis'},
      {n:'49', name:"The Lost Jedi's Return", artist:'Adam Schickling'},
      {n:'50', name:'Luke Skywalker and R2-D2', artist:'Greg & Tim Hildebrandt'},
      {n:'51', name:'Passage to Alderaan', artist:'Mike Kupka'},
      {n:'52', name:"Return to Jabba's Palace", artist:'Mike Kupka'},
      {n:'53', name:'Calming Touch', artist:'Mike Kupka'},
      {n:'54', name:'On Mustafar', artist:'Ryan Church'},
      {n:'55', name:'Against the Dark Side', artist:'Mark Chiarello'},
      {n:'56', name:'Daring Deception', artist:'Steven Chorney'},
      {n:'57', name:"IG-11's Initiative", artist:'David Rabbitte'},
      {n:'58', name:'Victory and Defeat', artist:'Danny Haas'},
      {n:'59', name:'Too Strong for Blasters', artist:'Jeremy Saliba'},
      {n:'60', name:'Count Dooku', artist:'Gabz'},
      {n:'61', name:'Director Krennic', artist:'Gabz'},
      {n:'62', name:'Lando Calrissian', artist:'Gabz'},
      {n:'63', name:'From Hero to Villain', artist:'Tsuneo Sanda'},
      {n:'64', name:'Stormtroopers', artist:'Tsuneo Sanda'},
      {n:'65', name:"The Bounty Hunter's Prize", artist:'Benjamin Carre'},
      {n:'66', name:'Rescue of Geonosis', artist:'Candice Dailey'},
      {n:'67', name:'An Understanding', artist:'Candice Dailey'},
      {n:'68', name:'Dark Aspirations', artist:'Candice Dailey'},
      {n:'69', name:'The High Ground', artist:'PhaseRunner'},
      {n:'70', name:'The Destiny of a Jedi', artist:'Ignacio RC'},
      {n:'71', name:'THE DUEL: KYLO REN', artist:'Richard Luong'},
      {n:'72', name:'THE DUEL: REY', artist:'Richard Luong'},
      {n:'73', name:'One Last Lesson, Ahsoka Tano vs Darth Maul', artist:'Ian Macdonald'},
      {n:'74', name:'Ahsoka Tano', artist:'Juan Carlos Ruiz Burgos'},
      {n:'75', name:'Little Droidsmith', artist:'Juan Carlos Ruiz Burgos'},
      {n:'76', name:'Call the Jedi', artist:'Akirant'},
      {n:'77', name:'I Will Watch Over Him', artist:'Kayla Woodside'},
      {n:'78', name:'The Choice', artist:'Kayla Woodside'},
      {n:'79', name:'The Awakening', artist:'Zoltan Simon'},
      {n:'80', name:'Conquering Shadow', artist:'Raymond Swanland'},
      {n:'81', name:'A Clan of Two', artist:'Jerry Vanderstelt'},
      {n:'82', name:'Holding Hope', artist:'Robert Hendrickson'},
      {n:'83', name:'Luke Skywalker', artist:'Alice X. Zhang'},
      {n:'84', name:'Han Solo', artist:'Alice X. Zhang'},
      {n:'85', name:'Battle of Mos Espa', artist:'Pablo Olivera'},
      {n:'86', name:'Imperial Fleet', artist:'Paul Youll'},
      {n:'87', name:"Han Solo's Rescue", artist:'Bryant Eastman'},
      {n:'88', name:'Following Orders', artist:'Chris Dee'},
      {n:'89', name:'Hoth Evacuation', artist:'Darren Tan'},
      {n:'90', name:'You Are Our Only Hope', artist:'Rodel Gonzalez'},
      {n:'91', name:'Standoff', artist:'Rodel Gonzalez'},
      {n:'92', name:'Yoda', artist:'Rodel Gonzalez'},
      {n:'93', name:'Falcon Rising', artist:'Mark Chilcott'},
      {n:'94', name:'Mustafar Takeoff', artist:'Mark Chilcott'},
      {n:'95', name:'Disciples of the Empire', artist:'Jaime Carrillo'},
      {n:'96', name:'Trouble on Tatooine', artist:'Hugh Fleming'},
      {n:'97', name:'Ewok No Evil', artist:'Craig Skaggs'},
      {n:'98', name:'Goodbye for Now', artist:'Al Abbazia'},
      {n:'99', name:'Forged By Destiny', artist:'Al Abbazia'},
      {n:'100', name:'Ahsoka Returns', artist:'Al Abbazia'},
    ]
  },
  {
    id: 'art-sith', type: 'insert', title: 'ART OF THE SITH — 10 CARDS',
    cards: [
      {n:'AS-1', name:'Chancellor Palpatine', artist:'Jason Thomas'},
      {n:'AS-2', name:'Darth Sidious', artist:'Jason Thomas'},
      {n:'AS-3', name:"Darth Vader's Mask", artist:'Jason Thomas'},
      {n:'AS-4', name:'Darth Vader', artist:'Jason Thomas'},
      {n:'AS-5', name:'Count Dooku', artist:'Jason Thomas'},
      {n:'AS-6', name:'Darth Nihilus', artist:'Jason Thomas'},
      {n:'AS-7', name:'Darth Maul', artist:'Jason Thomas'},
      {n:'AS-8', name:'Galactic Maul', artist:'Jason Thomas'},
      {n:'AS-9', name:'Yoda meets Darth Bane', artist:'Jason Thomas'},
      {n:'AS-10', name:'Darth Revan', artist:'Jason Thomas'},
    ]
  },
  {
    id: 'art-naboo', type: 'insert', title: 'ART OF NABOO — 15 CARDS',
    cards: [
      {n:'AN-1', name:'Theed Power Generator', artist:'Balance Sheet'},
      {n:'AN-2', name:'Great Grass Plains', artist:'Balance Sheet'},
      {n:'AN-3', name:'Varykino Retreat', artist:'Balance Sheet'},
      {n:'AN-4', name:'Theed Palace', artist:'Balance Sheet'},
      {n:'AN-5', name:'Naboo Royal Starship', artist:'Balance Sheet'},
      {n:'AN-6', name:'Theed Street', artist:'Balance Sheet'},
      {n:'AN-7', name:'Gungan Sacred Place', artist:'Balance Sheet'},
      {n:'AN-8', name:'Theed Plaza', artist:'Balance Sheet'},
      {n:'AN-9', name:'Queen Amidala', artist:'Balance Sheet'},
      {n:'AN-10', name:'N-1 Starfighter', artist:'Balance Sheet'},
      {n:'AN-11', name:'Otoh Gunga', artist:'Balance Sheet'},
      {n:'AN-12', name:'Lake Country', artist:'Balance Sheet'},
      {n:'AN-13', name:"Padmé's Funeral Procession", artist:'Balance Sheet'},
      {n:'AN-14', name:'Naboo Abyss', artist:'Balance Sheet'},
      {n:'AN-15', name:"Padmé Amidala's Funeral", artist:'Balance Sheet'},
    ]
  },
  {
    id: 'darth-maul', type: 'insert', title: 'PHANTOM MENACE 25TH — ART OF DARTH MAUL — 15 CARDS',
    cards: [
      {n:'AM-1', name:'Star Wars: The Phantom Menace #3 Comic Cover Art', artist:'Hugh Fleming'},
      {n:'AM-2', name:'Sith Arrival', artist:'Doug Cowan'},
      {n:'AM-3', name:'Jedi Slayer', artist:'Brian Rood'},
      {n:'AM-4', name:"Darth Maul's Assets", artist:'Archives'},
      {n:'AM-5', name:'A Mystery Named Maul', artist:'Brian Rood'},
      {n:'AM-6', name:'Darth Maul Galaxy 7', artist:'Mark Mchaley'},
      {n:'AM-7', name:"A Sith's Dark Vision", artist:'Archives'},
      {n:'AM-8', name:'Battle Worn', artist:'Archives'},
      {n:'AM-9', name:'Darth Maul', artist:'Christian Alzmann'},
      {n:'AM-10', name:'Sinister Shadow', artist:'Zoltan Simon'},
      {n:'AM-11', name:'Darth Maul', artist:'Juan Burgos'},
      {n:'AM-12', name:'Crimson Blades', artist:'Archives'},
      {n:'AM-13', name:'The Dark Duel', artist:'Laz Marquez'},
      {n:'AM-14', name:'Double Bladed', artist:'Tsuneo Sanda'},
      {n:'AM-15', name:'Infiltrator', artist:'Doug Cowan'},
    ]
  },
  {
    id: 'power-dark', type: 'insert', title: 'POWER OF THE DARKSIDE — 15 CARDS',
    cards: [
      {n:'PD-1', name:'Anakin Skywalker and His Mother', artist:'Traci Easterday'},
      {n:'PD-2', name:'Mortis Vision', artist:'Traci Easterday'},
      {n:'PD-3', name:"Obi-Wan Kenobi's Death", artist:'Traci Easterday'},
      {n:'PD-4', name:'Anakin Skywalker Kills Dooku', artist:'Traci Easterday'},
      {n:'PD-5', name:"Yoda Dismisses Anakin Skywalker's Fears", artist:'Traci Easterday'},
      {n:'PD-6', name:'Anakin Skywalker Stops Mace Windu', artist:'Traci Easterday'},
      {n:'PD-7', name:'Lord Vader', artist:'Traci Easterday'},
      {n:'PD-8', name:'Storming the Jedi Temple', artist:'Traci Easterday'},
      {n:'PD-9', name:'Mustafar', artist:'Traci Easterday'},
      {n:'PD-10', name:'Darth Vader Arrives on Malachor', artist:'Traci Easterday'},
      {n:'PD-11', name:'Darth Vader vs Ahsoka Tano', artist:'Traci Easterday'},
      {n:'PD-12', name:'Darth Vader vs Obi-Wan Kenobi', artist:'Traci Easterday'},
      {n:'PD-13', name:'Tantive IV Hallway Massacre', artist:'Traci Easterday'},
      {n:'PD-14', name:'Bespin', artist:'Traci Easterday'},
      {n:'PD-15', name:'Darth Vader World Between Worlds', artist:'Traci Easterday'},
    ]
  },
  {
    id: 'galactic-empire', type: 'insert', title: 'GALACTIC EMPIRE ART — 15 CARDS',
    cards: [
      {n:'GE-1', name:'Grand Admiral Thrawn', artist:'Uzuri Art'},
      {n:'GE-2', name:'The Grand Inquisitor', artist:'Uzuri Art'},
      {n:'GE-3', name:"Emperor's Royal Guard", artist:'Uzuri Art'},
      {n:'GE-4', name:'Emperor Palpatine', artist:'Uzuri Art'},
      {n:'GE-5', name:'Grand Moff Tarkin', artist:'Uzuri Art'},
      {n:'GE-6', name:'Director Krennic', artist:'Uzuri Art'},
      {n:'GE-7', name:'Captain Enoch', artist:'Uzuri Art'},
      {n:'GE-8', name:'Second Sister', artist:'Uzuri Art'},
      {n:'GE-9', name:'Night Trooper', artist:'Uzuri Art'},
      {n:'GE-10', name:'Death Trooper', artist:'Uzuri Art'},
      {n:'GE-11', name:'Dedra Meero', artist:'Uzuri Art'},
      {n:'GE-12', name:'Iden Versio', artist:'Uzuri Art'},
      {n:'GE-13', name:'Moff Gideon', artist:'Uzuri Art'},
      {n:'GE-14', name:'Reva', artist:'Uzuri Art'},
      {n:'GE-15', name:'Darth Vader', artist:'Uzuri Art'},
    ]
  },
  {
    id: 'armor', type: 'insert', title: 'ARMOR SHADOWBOX — 15 CARDS',
    cards: [
      {n:'ASB-1', name:'Commander Cody Helmet', artist:''},
      {n:'ASB-2', name:'Captain Rex Helmet', artist:''},
      {n:'ASB-3', name:'Bo-Katan Kryze Helmet', artist:''},
      {n:'ASB-4', name:'The Mandalorian', artist:''},
      {n:'ASB-5', name:'Darth Vader Helmet', artist:''},
      {n:'ASB-6', name:'Boba Fett Helmet', artist:''},
      {n:'ASB-7', name:"Jess Pava's Resistance Pilot Helmet", artist:''},
      {n:'ASB-8', name:'Sabine Wren Helmet', artist:''},
      {n:'ASB-9', name:'Kylo Ren Helmet', artist:''},
      {n:'ASB-10', name:'Imperial Royal Guard Helmet', artist:''},
      {n:'ASB-11', name:'Death Trooper Helmet', artist:''},
      {n:'ASB-12', name:'Jango Fett Helmet', artist:''},
      {n:'ASB-13', name:'Captain Phasma Helmet', artist:''},
      {n:'ASB-14', name:'Captain Enoch Helmet', artist:''},
      {n:'ASB-15', name:'Darth Revan Helmet', artist:''},
    ]
  },
  {
    id: 'one-force', type: 'insert', title: 'ONE WITH THE FORCE — 5 CARDS (1/1 SUPERFRACTORS)',
    cards: [
      {n:'OF-1', name:'Yoda', artist:''},
      {n:'OF-2', name:'Obi-Wan Kenobi', artist:''},
      {n:'OF-3', name:'Qui-Gon Jinn', artist:''},
      {n:'OF-4', name:'Count Dooku', artist:''},
      {n:'OF-5', name:'Darth Vader', artist:''},
    ]
  },
  {
    id: 'figure', type: 'insert', title: 'ACTION FIGURE VARIANT COMIC COVERS — 5 CARDS',
    cards: [
      {n:'VC-1', name:'Luke Skywalker', artist:'John Tyler Christopher'},
      {n:'VC-2', name:'Anakin Skywalker', artist:'John Tyler Christopher'},
      {n:'VC-3', name:'Princess Leia Organa', artist:'John Tyler Christopher'},
      {n:'VC-4', name:'Lando Calrissian', artist:'John Tyler Christopher'},
      {n:'VC-5', name:'Grand Admiral Thrawn', artist:'John Tyler Christopher'},
    ]
  },
  {
    id: 'auto-single', type: 'auto', title: 'GALAXY AUTOGRAPHS — 55 CARDS',
    cards: [
      {n:'A-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'A-AB', name:'Ahmed Best', artist:'Jar Jar Binks'},
      {n:'A-AS', name:'Andy Serkis', artist:'Kino Loy'},
      {n:'A-BD', name:'Benicio Del Toro', artist:'DJ'},
      {n:'A-BL', name:'Billie Lourd', artist:'Lieutenant Connix'},
      {n:'A-BM', name:'Ben Mendelsohn', artist:'Orson Krennic'},
      {n:'A-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'A-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'A-DM', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'A-DR', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'A-EC', name:'Emilia Clarke', artist:"Qi'ra"},
      {n:'A-EH', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'A-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'A-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'A-FP', name:'Freddie Prinze Jr', artist:'Kanan Jarrus'},
      {n:'A-FS', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'A-GE', name:'Giancarlo Esposito', artist:'Moff Gideon'},
      {n:'A-GL', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'A-GO', name:"Genevieve O'Reilly", artist:'Mon Mothma'},
      {n:'A-HC', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'A-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'A-IM', name:'Ian McDiarmid', artist:'Emperor Palpatine'},
      {n:'A-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'A-JB', name:'Jennifer Beals', artist:'Garsa Fwip'},
      {n:'A-JE', name:'Joel Edgerton', artist:'Owen Lars'},
      {n:'A-JL', name:'John Leguizamo', artist:'Gor Koresh'},
      {n:'A-KK', name:'Keira Knightley', artist:'Sabé'},
      {n:'A-KS', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'A-LD', name:'Laura Dern', artist:'Vice Admiral Holdo'},
      {n:'A-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'A-ME', name:'Maya Erskine', artist:'Sully'},
      {n:'A-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'A-MI', name:'Moses Ingram', artist:'Reva'},
      {n:'A-MM', name:'Mads Mikkelsen', artist:'Galen Erso'},
      {n:'A-MN', name:'Ming-Na Wen', artist:'Fennec Shand'},
      {n:'A-MW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'A-MZ', name:"Lupita Nyong'o", artist:'Maz Kanata'},
      {n:'A-NB', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'A-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'A-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'A-OI', name:'Oscar Isaac', artist:'Poe Dameron'},
      {n:'A-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'A-RD', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'A-RI', name:'Daisy Ridley', artist:'Rey'},
      {n:'A-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'A-SG', name:'Sarah Michelle Gellar', artist:'Seventh Sister'},
      {n:'A-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'A-SK', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'A-SO', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'A-SW', name:'Sam Witwer', artist:'Darth Maul'},
      {n:'A-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'A-TO', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'A-TW', name:'Taika Waititi', artist:'IG-11'},
      {n:'A-WD', name:'Warwick Davis', artist:'Wicket W. Warrick'},
      {n:'A-WH', name:'Werner Herzog', artist:'The Client'},
      {n:'A-ZB', name:'Zach Braff', artist:'Freck'},
    ]
  },
  {
    id: 'auto-dual', type: 'auto', title: 'DUAL AUTOGRAPHS — 6 CARDS',
    cards: [
      {n:'DA-DO', name:'Daisy Ridley / Oscar Isaac', artist:'Rey / Poe Dameron'},
      {n:'DA-DS', name:'Diego Luna / Stellan Skarsgård', artist:'Cassian / Luthen'},
      {n:'DA-LO', name:'Laura Dern / Oscar Isaac', artist:'Holdo / Poe Dameron'},
      {n:'DA-LW', name:'Wes Chatham / Lars Mikkelsen', artist:'Enoch / Thrawn'},
      {n:'DA-RA', name:'Rosario Dawson / Ariana Greenblatt', artist:'Ahsoka Tano'},
      {n:'DA-RM', name:'Mary Elizabeth Winstead / Rosario Dawson', artist:'Hera / Ahsoka'},
    ]
  },
  {
    id: 'auto-triple', type: 'auto', title: 'TRIPLE AUTOGRAPHS — 4 CARDS',
    cards: [
      {n:'TA-DAS', name:'Diego Luna / Stellan Skarsgård / Adria Arjona', artist:'Andor Cast'},
      {n:'TA-GFH', name:'Gary Beadle / Fiona Shaw / Diego Luna', artist:'Andor Cast'},
      {n:'TA-HES', name:'Ewan McGregor / Samuel L. Jackson / Hayden Christensen', artist:'Prequel Cast'},
      {n:'TA-RNM', name:'Mary Elizabeth Winstead / Rosario Dawson / Natasha Liu Bordizzo', artist:'Ahsoka Cast'},
    ]
  },
  {
    id: 'auto-quad', type: 'auto', title: 'QUAD AUTOGRAPHS — 4 CARDS',
    cards: [
      {n:'QA-DADK', name:'Denise Gough / Adria Arjona / Kyle Soller / Diego Luna', artist:'Andor Cast'},
      {n:'QA-LWDI', name:'Diana Lee Inosanto / Wes Chatham / Lars Mikkelsen / Ivanna Sakhno', artist:'Ahsoka Cast'},
      {n:'QA-NHES', name:'Samuel L. Jackson / Ewan McGregor / Hayden Christensen / Natalie Portman', artist:'Prequel Cast'},
      {n:'QA-RNLW', name:'Lars Mikkelsen / Natasha Liu Bordizzo / Wes Chatham / Rosario Dawson', artist:'Ahsoka Cast'},
    ]
  },
  {
    id: 'sketch', type: 'sketch', title: 'SKETCH CARD ARTISTS',
    cards: [
      'Marlo Agunos','Adam Beck','Alex Mines','Allen Grimes','Andrew Fry',
      'Andy Hanks','Angel S Aviles','Anthony Pietszak','Antni Ellison','Basak Kahraman',
      'Bobby B','Brad Hudson','Brandon Klein','Brett Farr','Bryan "Kaiser" Tillman',
      'Candice Clemmons','Candice Dailey','Cisco Rivera','Clinton Yeager','Dan Bergren',
      'Dan Cooney','Dan Gorman','Dan Lawler','Daniel Chavez','Daniel Riveron',
      'David "Dove" McHargue','David Willingham','Dawn Murphy','Debjit Kar','Derek Johnson',
      'Don Nguyen','Dyj','Elvin A Hernandez','Emrah Cildir','Emre Varlibas',
      'Eric Lehtonen','Eric Medina','Erick Basio','Erik Muller','Evgheni Batu',
      'Frank Sansone','Ian McKesson','Isiah Xavier Bradley','J. Hammond','Jackson Ong',
      'James Boyd','Jamie Richards','Jason Christner','Jason Davies','Jason Montoya',
      'Jason Queen','Jason Saldajeno','Jason Sobol','Jay Manchand','Jeffrey Benitez',
      'Jessica Hickman',"Jim O'Riley",'Joe Ortiz','Joey Mason','John Anthony Rodriguez',
      'John Bruce','John Still','Julia McKenzie','Kang Jing','Karl Jones',
      'Keith Farnum','Kevin Scott Jacobs','Krishna Sharma','Limuel Pinzon','Lindsey Greyling',
      'Lukas Maurer','Luke Seavers','Marcia Dye','Matt Maldonado','Matt Stewart',
      'Matthew Sutton','Michael LaPeruta','Michael Mastermaker','Michael Munshaw','Michael Ofiaza',
      'Michael Sealie','Mike Dalzell','Mike Davidson','Mongola Das','Nathaniel Howard',
      'Neil A Brady','Neil Camera','Nick Gribbon','Nick Sutphin','Oscar Chavez',
      'Patricio Carrasco','Patrick Giles','Phillip Trujillo','Rachel Jane','Rebeca Louro',
      'Rees Chua-Finlay','Rich "RAM" Molinelli','Rico Dela Rosa','RJ Tomascik',
      'Robert "El Smetcho" Garcia','Robert Demers','Robert Hendrickson','Roy Cover',
      'Rugved Bhuskute','Rusty Gilligan'
    ].map((a, i) => ({n: `SK-${i+1}`, name: a, artist: 'Sketch Card Artist'}))
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);
